import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import ConfBar from '../ConfBar/ConfBar';
import apis from '../../api';
import { Divider } from 'primereact/divider';
import useWindowDimensions from '../hooks/useDimensions';
import { InputText } from 'primereact/inputtext';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Users
Description : Pagina de Users para el CRUD de los usuarios del aplicativo remunerlite.
Date Autor Modification
================================================================================
15/10/2021 Cristian Andres Pizo Mina - Pagina de Cargo
================================================================================ */
export default function Users() {
    const toast = useRef(null);
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [password3, setPassword3] = useState("");
    const [statePassword, setStatePassword] = useState(true);
    const [statePassword2, setStatePassword2] = useState(true);
    const [statePassword3, setStatePassword3] = useState(true);
    const [loadingPassword, setLoadingPassword] = useState(false);
    const headers = { authorization: localStorage.getItem('token') }
    const elementWidth = { width: "90%" }
    const { width } = useWindowDimensions()

    function validarCampos() {
        if (password == "") {
            setStatePassword(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar contraseña actual', life: 4000 })
            return false
        } if (password2 == "") {
            setStatePassword(true)
            setStatePassword2(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar nueva contraseña', life: 4000 })
            return false
        } if (password3 == "") {
            setStatePassword(true)
            setStatePassword3(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar nueva contraseña', life: 4000 })
            return false
        }
        setStatePassword(true)
        setStatePassword(true)
        setStatePassword(true)
        return true
    }

    function comprarPassword() {
        if (password2 != password3) {
            setStatePassword2(false)
            setStatePassword3(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Las contraseñas no conciden', life: 4000 })
            return false
        }
        setStatePassword2(true)
        setStatePassword3(true)
        return true
    }

    function clean() {
        setPassword("");
        setPassword2("");
        setPassword3("");
    }

    function newPassword() {

        if (validarCampos()) {
            if (comprarPassword()) {
                setLoadingPassword(true)
                const username = localStorage.getItem('user').toLowerCase()
                const passwordOld = password;
                const passworNew = password2;
                const passworConfirm = password3;

                const newPassword = {
                    USERNAME: username,
                    PASSOLD: passwordOld,
                    PASSNW: passworNew,
                    PASSNW_CONF: passworConfirm
                }
                apis.PostChange_password(newPassword, headers).then(res => {
                    setLoadingPassword(false)
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Contraseña actualizada exitosamente', life: 4000 });
                    clean();
                }).catch(err => {
                    setLoadingPassword(false)
                    toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
                })
            }
        }
    }

    const passwordHeader = <h6>Seleccione su contraseña</h6>;
    const passwordFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Sugerencias</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Al menos una mayúscula</li>
                <li>Al menos un número</li>
                <li>Al menos un caracter especial</li>
                <li>Mínimo 8 caracteres</li>
            </ul>
        </React.Fragment>
    );


    return (

        <div className='mt-6'>
            <Toast ref={toast} />

            <div className="pt-5">
                <ConfBar />
            </div>

            <div class="card surface-section w-10 m-auto  mt-6">

                <div class="col-12 ">
                    <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
                        <span className="text-900">Gestión de contraseña</span>
                    </div>
                </div>
                <div class="flex flex-row justify-content-center">

                    <div class="col-6">
                        <div class="grid mt-3">
                            <div class="col-10 m-auto">
                                <div className="field">
                                    {width <= 732 && <label style={elementWidth} htmlFor="inputgroup">Contraseña actual</label>}
                                    <div className="p-inputgroup">
                                        {width > 732 && <span className="p-inputgroup-addon">
                                            <i className="pi pi-lock"></i>
                                        </span>}
                                        <span className="p-float-label">
                                            <Password id="inputgroup" autocomplete="off" style={elementWidth} type="password"
                                                value={password} onChange={(e) => setPassword(e.target.value)} feedback={false}
                                                className={statePassword ? null : "p-invalid"} toggleMask inputStyle={{ width: 'auto' }}
                                            />
                                            {width > 732 && <label htmlFor="inputgroup">Contraseña actual</label>}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-10 m-auto">
                                <div className="field">
                                    {width <= 732 && <label style={elementWidth} htmlFor="inputgroup">Nueva contraseña</label>}
                                    <div className="p-inputgroup">
                                        {width > 732 && <span className="p-inputgroup-addon">
                                            <i className="pi pi-lock"></i>
                                        </span>}
                                        <span className="p-float-label">
                                            <Password id="password" name="password" value={password2} onChange={(e) => setPassword2(e.target.value)} className={statePassword2 ? null : "p-invalid"}
                                                toggleMask header={passwordHeader} footer={passwordFooter} style={elementWidth} inputStyle={{ width: 'auto' }}
                                                mediumRegex={"^(((?=.*[!@#$&()\\-`.+,/\"])(?=.*[A-Z]))|((?=.*[!@#$&()\\-`.+,/\"])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})."}
                                                strongRegex={"^(?=.*[!@#$&()\\-`.+,/\"])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"}
                                                weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte" promptLabel="Digite su contraseña" />
                                            {width > 732 && <label htmlFor="inputgroup">Nueva contraseña</label>}
                                        </span>

                                    </div>
                                </div>
                            </div>
                            <div class="col-10 m-auto">
                                <div className="field">
                                    {width <= 732 && <label style={elementWidth} htmlFor="inputgroup">Confirmar contraseña</label>}
                                    <div className="p-inputgroup">
                                        {width > 732 && <span className="p-inputgroup-addon">
                                            <i className="pi pi-lock"></i>
                                        </span>}
                                        <span className="p-float-label">
                                            <Password id="inputgroup" autocomplete="off" style={elementWidth} type="password" value={password3} inputStyle={{ width: 'auto' }}
                                                onChange={(e) => setPassword3(e.target.value)} feedback={false} className={statePassword3 ? null : "p-invalid"} toggleMask />
                                            {width > 732 && <label htmlFor="inputgroup">Confirmar contraseña</label>}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-10 m-auto">
                                <hr class="my-3 mx-0 border-top-1 " />
                                <Button label="Actualizar contraseña" onClick={newPassword} loading={loadingPassword} />
                            </div>
                        </div>
                    </div>
                    <div class="col-6"
                        style={{
                            display: width < 732 && 'none'
                        }}
                    >
                        <img class="w-10 h-10 shadow-4"
                            style={{
                                borderRadius: "50px",
                            }}
                            src={process.env.REACT_APP_PASSWORD}></img>
                    </div>
                </div>
            </div>
        </div>
    );
}